import '@mds/prescriber-design-system/dist/pds-tailwind.css';
import './styles/normalize.scss';
import 'lato-font';
import 'icons/styles.css';
import './styles/main.scss';
import './styles/animate.css';
import 'vue-search-select/dist/VueSearchSelect.css';
import 'vue-select/dist/vue-select.css';

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import './styles/tooltip.css';

import VueImageZoomer from 'vue-image-zoomer';
import 'vue-image-zoomer/dist/style.css';
import './styles/imageZoomer.css';

import { VueRecaptcha } from 'vue-recaptcha';
import { ModelSelect } from 'vue-search-select';

import Vue3CountryIntl from 'vue3-country-intl';
import 'vue3-country-intl/lib/vue3-country-intl.css';

// shared component styles
import '@/components/shared/form/FormGroup.scss';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { initAxios } from '@/services';
import { createGtm, useGtm } from '@gtm-support/vue-gtm';

import { createApp } from 'vue';
import App from './App.vue';
import store from '@/store';
import router from './router';
import mitt from 'mitt';
import vClickout from 'vue3-clickout';
import IdlePlugin from './plugins/idle'; // Custom idle plugin

// PrescriberDesignSystem - Web Components Section
import PdsNavigation from '@mds/prescriber-design-system';
import Alert from '@/components/webcomponents/Alert';
import Card from '@/components/webcomponents/Card';
import ModalDialog from '@/components/webcomponents/ModalDialog';
import Notification from '@/components/webcomponents/Notification';
import PageHeader from '@/components/webcomponents/PageHeader';
import Toggle from '@/components/webcomponents/Toggle';
import InputGroups from './components/webcomponents/InputGroups.vue';
import ComboBoxes from './components/webcomponents/ComboBoxes.vue';
import Tabs from './components/webcomponents/Tabs.vue';
import Tables from './components/webcomponents/Tables.vue';

initAxios();
export const app = createApp(App);
const emitter = mitt();
const gtmPlugin = createGtm({
  id: 'GTM-5JZVM3L',
  queryParams: {},
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  ignoredViews: []
});

app.use(store);
app.use(router);
app.use(gtmPlugin);
app.use(FloatingVue);
app.use(VueImageZoomer);
app.use(vClickout);
app.use(PdsNavigation);
app.use(IdlePlugin, {
  // Use the custom idle plugin
  idleTime: 8 * 60 * 60 * 1000, // 8 hours
  onIdle: () => {
    console.log('User has been idle for 8 hours, reloading the page.');
    window.location.reload(true);
  }
});

// shared
import Button from '@/components/shared/Button';
import Heading from '@/components/shared/Heading';
import InputGroup from '@/components/shared/form/InputGroup';
import InputGroupSimple from '@/components/shared/form/simple/InputGroup';
import InputGroupSimple2 from '@/components/shared/form/simple/InputGroup2';
import SelectGroup from '@/components/shared/form/SelectGroup';
import TextareaGroup from '@/components/shared/form/TextareaGroup';
import Paragraph from '@/components/shared/Paragraph';
import Overlay from '@/components/shared/Overlay';
import mButton from '@/components/shared/webcomponents/mButton';
import mSelect from '@/components/shared/webcomponents/mSelect';
import mInput from '@/components/shared/webcomponents/mInput';

app.config.productionTip = false;
// register vue components global
app.component(Button.name, Button);
app.component(Heading.name, Heading);
app.component(InputGroup.name, InputGroup);
app.component(Paragraph.name, Paragraph);
app.component(Overlay.name, Overlay);
app.component(InputGroupSimple.name, InputGroupSimple);
app.component(InputGroupSimple2.name, InputGroupSimple2);
app.component(SelectGroup.name, SelectGroup);
app.component(TextareaGroup.name, TextareaGroup);
app.component('MButton', mButton);
app.component('MSelect', mSelect);
app.component('MInput', mInput);
app.component('VueRecaptcha', VueRecaptcha);
app.component('ModelSelect', ModelSelect);
app.component(Vue3CountryIntl.name, Vue3CountryIntl);

// Web components section
app.component(Alert.name, Alert);
app.component(Card.name, Card);
app.component('ModalDialog', ModalDialog);
app.component('Notification', Notification);
app.component(PageHeader.name, PageHeader);
app.component('Toggle', Toggle);
app.component(InputGroups.name, InputGroups);
app.component(ComboBoxes.name, ComboBoxes);
app.component('Tabs', Tabs);
app.component('Tables', Tables);

// Filters
import { formatDate } from './filters/dateUtils.js';

// Mixin
import LoadAlternateImage from '@/mixins/LoadAlternateImage.js';
app.mixin(LoadAlternateImage);

// Google recaptcha site key
app.config.globalProperties.$googleRecaptchaSiteKey = '6LecOWEUAAAAAL9AUSqbWz_ngQb-pBvIVWFiYQGn';
app.config.globalProperties.$featureFlag = [];
app.config.globalProperties.$emitter = emitter;
app.config.globalProperties.$formatDate = formatDate;
app.config.globalProperties.$isInIframe = window.self !== window.top;
app.config.globalProperties.$gtm = {
  push: (...args) => {
    const gtmInstance = useGtm();
    return gtmInstance.push(...args);
  }
};
app.provide('$gtm', app.config.globalProperties.$gtm);

app.mount('#app');
